export interface PlatformTenant {
  type: string
  id: string
  attributes?: {
    name: string
    ref_ultimate_tenant_id: string
    ref_id: string
    ref_type: "edfx"
    country_code: string
    total_area: number
    total_net_rent_monthly: number
    walt: number
    total_units: number
    esg_global_score: number
    legal_entity_identifier: string
    industry_primary_label: string
    naics_core_label: string
    naics_primary_label: string
    naics_secondary_label: string
    sic_core_label: string
    sic_primary_label: string
    sic_secondary_label: string
    employee_count: number
    cortera_payment_rating_score: number
    operating_revenue: number
    p_l_before_tax: number
    p_l_for_period: number
    cash_flow: number
    total_assets: number
    shareholders_funds: number
    current_ratio: number
    profit_margin: number
    roe_using_p_l_before_tax: number
    roce_using_p_l_before_tax: number
    solvency_ratio: number
  }
}

export const tenantAttributes = [
  "name",
  "ref_ultimate_tenant_id",
  "ref_id",
  "ref_type",
  "country_code",
  "total_area",
  "total_net_rent_monthly",
  "walt",
  "total_units",
  "esg_global_score",
  "industry_primary_label",
  "legal_entity_identifier",
  "naics_core_label",
  "naics_primary_label",
  "naics_secondary_label",
  "sic_core_label",
  "sic_primary_label",
  "sic_secondary_label",
  "employee_count",
  "cortera_payment_rating_score",
  "operating_revenue",
  "p_l_before_tax",
  "p_l_for_period",
  "cash_flow",
  "total_assets",
  "shareholders_funds",
  "current_ratio",
  "profit_margin",
  "roe_using_p_l_before_tax",
  "roce_using_p_l_before_tax",
  "solvency_ratio",
  "measured_by"
]
